import { Capacitor } from '@capacitor/core';
import { SignInWithApple } from '@capacitor-community/apple-sign-in';

export async function canUseNativeAppleSignIn(): Promise<boolean> {
  return Capacitor.isNativePlatform();
}

export async function nativeAppleSignIn(): Promise<{ identityToken: string; nickname?: string }> {
  const r = await SignInWithApple.authorize({
    clientId: 'ru.quoridorapp.signin',
    scopes: ['name', 'email'],
  });
  // Plugin returns identityToken on iOS native flow
  const identityToken = (r as any)?.response?.identityToken ?? (r as any)?.identityToken;
  const given = (r as any)?.response?.givenName ?? (r as any)?.givenName;
  const family = (r as any)?.response?.familyName ?? (r as any)?.familyName;
  const nickname = [given, family].filter(Boolean).join(' ').trim() || undefined;
  if (!identityToken) throw new Error('No identityToken from native Apple Sign In');
  return { identityToken, nickname };
}

